import React from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';
import CostToServeTooltip from './cts-tooltip';

export interface CashToServeInterface {
  costToServeYield: string;
}

const { darkInputBorder } = colors;

const SuperContainer = styled.div``;

const Container = styled.div`
  display: flex;
`;

const ClusterTitle = styled.div`
  color: ${darkInputBorder};
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const ClusterRowValue = styled.div`
  font-size: 18px;
  font-weight: 500;
  margin-right: 8px;
`;

export default ({ costToServeYield }: CashToServeInterface) => {
  return (
    <SuperContainer>
      <Container>
        <ClusterTitle>COST-TO-SERVE YIELD</ClusterTitle>
        <CostToServeTooltip top={-1} />
      </Container>
      <ClusterRowValue>{costToServeYield}</ClusterRowValue>
    </SuperContainer>
  );
};
